import css from "styled-jsx/css";
import { MOBILE_QUERY_MAX_WIDTH } from "constants/vp-sizes";
import colors from "styles/colors";

export const componentStyles = css.global`
  .all-rights-reserved-component {
    .monday-logo-wrapper {
      margin-bottom: 32px;
    }

    .details {
      font-size: 0.8125rem;
      line-height: 2;
      margin-bottom: 16px;
    }

    .icons-and-language {
      display: flex;
      flex-direction: column;

      .language-picker-wrapper {
        width: 120px;
        min-height: 20px;
      }
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .all-rights-reserved-component {
      display: flex;
      margin-left: 24px;

      .icons-wrapper {
        margin-left: 48px;
      }

      .language-picker-wrapper {
        margin-left: 40px;

        .language-picker-dialog-component-wrapper {
          right: 0 !important;
          left: auto !important;
        }
      }
    }
  }
`;

export const appIconsStyels = css.global`
  .app-icons {
    margin: 16px 0;

    .social-media-icon {
      &:hover rect {
        fill: ${colors["white"]};
      }
    }
  }
`;
